// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState} from 'react';
import cn from 'classnames';

import Icon_chevron_down
  from '../../../../../hola/pub/img/hola2023/icons/16/chevron_down.svg';
import {use_theme} from '../../../../../hola/pub/settings_ctx';
import {Checkbox} from '../../../../../hola/pub/lib/checkbox';
import {i_plan, i_plan_config} from '../../../../../hola/pub/plus/plus_types';
import styles from './unlimited_bandwidth.module.less';

type t_order_summary_props = {
    cls?: string;
    plan: i_plan;
    plan_config: i_plan_config;
    usage_charges: boolean;
    on_change_usage_charges: (val: boolean)=>void;
};

export const Unlimited_bandwidth=({cls, usage_charges,
  plan_config, plan, on_change_usage_charges}: t_order_summary_props)=>{
    const {theme} = use_theme();
    const [show, set_show] = useState(false);
    const package_gb = plan_config.limit.toFixed(2);
    const package_gb_110 = (plan_config.limit * 1.1).toFixed(2);
    const package_gb_10 = (plan_config.limit * 0.1).toFixed(2);
    const total= plan.price;
    const per_gb_cost = (total / plan_config.limit).toFixed(2);
    const per_10_cost = (total * 0.1).toFixed(2);

    return <div className={cn(cls, styles.unlimited_bandwidth,
      show && styles.opened)}>
      <p className={cn(theme.P, theme.med, styles.header)}>
        Need unlimited bandwidth?
      </p>
      <p className={cn(styles.checkbox_wrapper, theme.p14)}>
        <span>Enable additional usage charges</span>

        <Checkbox
          size="xs" mode="toggle" light
          checked={usage_charges}
          on_change={on_change_usage_charges}/>
      </p>
      <button
        className={styles.toggle_header}
        onClick={()=>set_show(x=>!x)}>
          {show ? 'Show less' : 'Show more'}
          <Icon_chevron_down className={styles.arrow}/>
      </button>
      <p className={cn(theme.p4, styles.toggle_body)}>
        When you enable additional usage charges, you agree to incur
        fees if your usage exceeds the limits of your current plan.
        For instance, if your plan includes {package_gb} GB of data
        per month and you use {package_gb_110} GB, you will be charged
        an extra fee for the additional {package_gb_10} GB of data.
        The overage fee is ${per_gb_cost} per GB  (total ${per_10_cost}).
        This charge will appear on your next billing cycle.
        To avoid unexpected charges, we recommend monitoring your usage
        regularly and considering an upgrade
        if you consistently exceed your plan's limits.</p>
    </div>;
};
